module.exports = __webpack_public_path__ + "static/img/dr-aya.2f0176b2.jpg";